import { VStack } from '@chakra-ui/react';
import { ScoreTypeEnum } from 'api-paths-cas';
import ScoreDetails, { EditQuestionScorePayload } from './ScoreDetails';

export interface IScore {
  type: ScoreTypeEnum;
  value: number | undefined;
  explanation: string | undefined;
  transcript?: string | undefined;
  withIndicator?: boolean;
}

interface AllScoresForQuestionProps {
  scores: IScore[];
  onSave: (payload: EditQuestionScorePayload) => void;
}

function AllScoresForQuestion(props: AllScoresForQuestionProps) {
  const { scores } = props;
  return (
    <VStack spacing="4">
      {scores?.map((score, index) => (
        <ScoreDetails
          key={index}
          type={score.type}
          value={score.value}
          withIndicator={score.withIndicator}
          explanation={score.explanation}
          transcript={score.transcript}
          onSave={props.onSave}
        />
      ))}
    </VStack>
  );
}

export default AllScoresForQuestion;
